/**
 * 브랜드·사업자·연락처 — 가입 화면·약관·개인정보처리방침이 같은 값을 쓴다.
 *
 * ★ **서비스명(liveGPT)과 사업자명(비하이브컴퍼니)은 다르다.** 화면·마케팅 문구는 서비스명,
 *   약관·개인정보처리방침의 계약 주체·보호책임자는 사업자명이다. 섞으면 법적 표시가 틀어진다.
 */
export const BRAND = {
  /** 표기 고정: 소문자 live + 대문자 GPT */
  name: 'liveGPT',
  homepage: 'https://livegpt.co.kr/',
  tagline: 'AI 검색에 인용되는 브랜드를 만듭니다',
  /** 로그인 화면의 한 줄 — 이게 무슨 서비스인지부터 말한다 */
  descriptor: 'AI 검색 최적화 서비스',
} as const;

export const COMPANY = {
  name: '비하이브컴퍼니',
  ceo: '노건일',
  /** 개인정보 보호책임자 */
  privacyOfficer: '노건일',
  registrationNo: '595-88-02921',
  mailOrderNo: '제2025-서울강남-01311호',
  address: '경기도 성남시 중원구 둔촌대로 84, 309호',
  email: 'contact@beehivecompany.co.kr',
  tel: '1522-5970',
  /** 랜딩(livegpt.co.kr)과 같은 채널 — 260917-admin-area-split */
  kakaoChannelUrl: 'https://pf.kakao.com/_GLxfiG/chat',
  /** 운영사의 공인 기록 — 서비스(liveGPT)가 아니라 회사의 것이다. 화면에는 "운영사" 캡션과 함께 둔다 */
  credentials: ['특허 제10-2995516호', '기업부설연구소', '벤처기업 확인'],
} as const;
